import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchTours = createAsyncThunk("tour/all-tours", async () => {
  const response = await fetch("https://joyfulserver.ddns.net:443/api/Tour/all-tours");
  const result = await response.json();
  return result.data;
});

export const fetchPrivateTours = createAsyncThunk("tour/all-private-tours", async () => {
  const response = await fetch("https://joyfulserver.ddns.net:443/api/Tour/all-private-tours");
  const result = await response.json();
  return result.data;
});

export const fetchAframes = createAsyncThunk("aframe/all-aframes", async () => {
  const response = await fetch("https://joyfulserver.ddns.net:443/api/Aframe/all-aframes");
  const result = await response.json();
  return result.data;
});

export const addAframe = createAsyncThunk(
  "aframe/add-aframe",
  async (newAframe) => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/Aframe/add-aframe",
      {
        method: "POST",
        body: newAframe,
      }
    );
    return await response.json();
  }
);

export const deleteAframe = createAsyncThunk(
  "tours/delete-aframe",
  async (aframeId) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/Aframe/delete-aframe/${aframeId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    return await response.json();
  }
);

export const getAframe = createAsyncThunk("aframes/aframe", async (id) => {
  const response = await fetch(
    `https://joyfulserver.ddns.net:443/api/Aframe/aframe/${id}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  const result = await response.json();
  return result.data;
});

export const fetchSpecialOfferTours = createAsyncThunk(
  "tours/all-special-tours",
  async () => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/Tour/all-special-offer-tours"
    );
    const result = await response.json();
    return result.data;
  }
);

export const fetchImagesFromGallery = createAsyncThunk(
  "tours/all-gallery-images",
  async (id) => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/Tour/all-special-offer-tours"
    );
    const result = await response.json();
    return result.data;
  }
);

export const fetchDiscountTours = createAsyncThunk(
  "tours/all-discount-tours",
  async () => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/Tour/all-discount-tours"
    );
    const result = await response.json();
    return result.data;
  }
);

export const fetchAllInActiveTours = createAsyncThunk(
  "tours/all-inactive-tours",
  async () => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/Tour/all-inactive-tours"
    );
    const result = await response.json();
    return result.data;
  }
);

export const deleteAllInActiveTours = createAsyncThunk(
  "tours/delete-inactive-tours",
  async () => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/Tour/delete-inactive-tours"
    );
  }
);

export const fetchLowToHighTours = createAsyncThunk(
  "tours/low-to-high-tours",
  async () => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/Tour/lowtohigh-tours"
    );
    const result = await response.json();
    return result.data;
  }
);

export const fetchHighToLowTours = createAsyncThunk(
  "tours/high-to-low-tours",
  async () => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/Tour/hightolow-tours"
    );
    const result = await response.json();
    return result.data;
  }
);

export const fetchMinAndMaxPriceTours = createAsyncThunk(
  "tours/min-and-max-tours",
  async ({ min, max }) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/Tour/minandmaxprice-tours?min=${min}&max=${max}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" }, // Bu header GET için zorunlu değil
      }
    );
    const result = await response.json();
    return result.data;
  }
);

export const fetchToursByCategoryId = createAsyncThunk(
  "tours/all-tours-by-category-id",
  async (id) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/Tour/all-tours-by-category-id/${id}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    // Cavabın düzgün status koduna malik olduğunu yoxlayın
    if (!response.ok) {
      throw new Error(`API xətası: ${response.statusText}`);
    }

    const result = await response.json();

    // JSON formatında düzgün məlumatın gəldiyini yoxlayın
    if (!result || !result.data) {
      throw new Error("Cavabdan düzgün məlumat alınmadı");
    }

    return result.data;
  }
);

export const fetchToursByCategoryName = createAsyncThunk(
  "tours/all-tours-by-category-name",
  async ({ name }) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/Tour/all-tours-by-category-name/${name}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" }, // Bu header GET için zorunlu değil
      }
    );
    const result = await response.json();
    return result.data;
  }
);

export const addTour = createAsyncThunk("tours/addTour", async (newTour) => {
  const response = await fetch("https://joyfulserver.ddns.net:443/api/Tour/add-tour", {
    method: "POST",
    body: newTour,
  });
  return await response.json();
});

export const deleteTour = createAsyncThunk(
  "tours/deleteTour",
  async (tourId) => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/Tour/delete-tour",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tourId),
      }
    );
    return await response.json();
  }
);

export const addTourImage = createAsyncThunk(
  "tourGallery/add-image",
  async (formData) => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/TourGallery/add-image",
      {
        method: "POST",
        body: formData, // FormData olarak gönderiyoruz
      }
    );
    console.log(formData);
    return await response.json();
  }
);


export const addHotel = createAsyncThunk("tours/addHotel", async (hotels) => {
  const response = await fetch("https://joyfulserver.ddns.net/api/Hotel/add-hotel", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(hotels), // diqqət: burada JSON.stringify olmalıdır
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return await response.json();
});



export const getTour = createAsyncThunk("tours/tour", async (slug) => {
  const response = await fetch(`https://joyfulserver.ddns.net:443/api/Tour/tour/${slug}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  const result = await response.json();
  return result.data;
});

export const changeStatus = createAsyncThunk(
  "tours/change-status",
  async (id) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/Tour/change-status/${id}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
  }
);
export const addDiscount = createAsyncThunk(
  "tours/add-discount-tour",
  async (dto) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/Tour/add-discount-tour`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dto),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to add discount");
    }

    return await response.json(); // <== **JSON cavabı qaytarırıq**
  }
);

const toursSlice = createSlice({
  name: "tours",
  initialState: {
    tours: [],
    privateTours : [],
    hotels:[],
    tourGalleries: [],
    specialOfferTours: [],
    discountTours: [],
    lowToHighTours: [],
    highToLowTours: [],
    categoryIdTours: [],
    categoryNameTours: [],
    minAndMaxPriceTours: [],
    inActiveTours: [],
    aframes: [],
    selectedAframe: [],
    images: [],
    selectedTour: null,
    status: "idle",
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      // 🔹 GET - Bütün turlar
      .addCase(fetchTours.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTours.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.tours = action.payload;
      })
      .addCase(fetchTours.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchPrivateTours.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPrivateTours.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.privateTours = action.payload;
      })
      .addCase(fetchPrivateTours.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchAllInActiveTours.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllInActiveTours.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.inActiveTours = action.payload;
      })
      .addCase(fetchAllInActiveTours.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // 🔹 GET - Bütün turlar
      .addCase(fetchAframes.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAframes.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.aframes = action.payload;
      })
      .addCase(fetchAframes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(addAframe.fulfilled, (state, action) => {
        state.aframes.push(action.payload);
      })

      .addCase(deleteAframe.fulfilled, (state, action) => {
        state.aframes = state.aframes.filter((pr) => pr.id !== action.payload);
      })

      .addCase(getAframe.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAframe.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedAframe = action.payload;
      })
      .addCase(getAframe.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(changeStatus.fulfilled, (state, action) => {
        state.status = "succeeded";
        const data = getTour(action.payload);
        state.tours = state.tours.filter((pr) => pr.id !== action.payload);
        state.inActiveTours.push(data);
      })
      .addCase(addDiscount.fulfilled, (state, action) => {
        state.status = "succeeded";
        
        // Gələn datanı yoxla
        console.log("API Response:", action.payload);
      
        if (!action.payload || !action.payload.tourId) {
          console.error("Invalid payload received:", action.payload);
          return;
        }
      
        // `getTour` funksiyasını burada istifadə etmək düz deyil, çünki o async ola bilər.
        const tourId = action.payload.tourId;
        state.tours = state.tours.filter((pr) => pr.id !== tourId);
        state.discountTours.push(action.payload); // Yeni endirimli turu əlavə et
      })

      .addCase(fetchToursByCategoryId.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchToursByCategoryId.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.categoryIdTours = action.payload;
      })
      .addCase(fetchToursByCategoryId.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchToursByCategoryName.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchToursByCategoryName.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.categoryNameTours = action.payload;
      })
      .addCase(fetchToursByCategoryName.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchSpecialOfferTours.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSpecialOfferTours.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.specialOfferTours = action.payload;
      })
      .addCase(fetchSpecialOfferTours.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchDiscountTours.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDiscountTours.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.discountTours = action.payload;
      })
      .addCase(fetchDiscountTours.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchHighToLowTours.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchHighToLowTours.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.highToLowTours = action.payload;
      })
      .addCase(fetchHighToLowTours.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchLowToHighTours.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLowToHighTours.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.lowToHighTours = action.payload;
      })
      .addCase(fetchLowToHighTours.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchMinAndMaxPriceTours.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMinAndMaxPriceTours.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.minAndMaxPriceTours = action.payload;
      })
      .addCase(fetchMinAndMaxPriceTours.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // 🔹 POST - Yeni tur əlavə etmək
      .addCase(addTour.fulfilled, (state, action) => {
        state.tours.push(action.payload);
      })

      .addCase(deleteTour.fulfilled, (state, action) => {
        state.tours = state.tours.filter((pr) => pr.id !== action.payload);
      })

      .addCase(deleteAllInActiveTours.fulfilled, (state, action) => {
        state.inActiveTours = [];
      })

      // Yeni şəkil əlavə edərkən
      .addCase(addTourImage.pending, (state) => {
        state.status = "loading"; // Şəkil yüklənərkən loading vəziyyətinə keçirik
      })
      .addCase(addTourImage.fulfilled, (state, action) => {
        state.status = "succeeded"; // Əgər şəkil uğurla əlavə olunubsa, status-u succeeded edirik
        // Burada şəkil əlavə edildikdən sonra onu `tourGalleries`-ə əlavə edə bilərik
        state.tourGalleries.push(action.payload);
      })
      .addCase(addTourImage.rejected, (state, action) => {
        state.status = "failed"; // Əgər şəkil əlavə edilə bilməzsə, failed vəziyyətinə keçirik
        state.error = action.error.message;
      })

      .addCase(addHotel.pending, (state) => {
        state.status = "loading"; // Şəkil yüklənərkən loading vəziyyətinə keçirik
      })
      .addCase(addHotel.fulfilled, (state, action) => {
        state.status = "succeeded"; // Əgər şəkil uğurla əlavə olunubsa, status-u succeeded edirik
        // Burada şəkil əlavə edildikdən sonra onu `tourGalleries`-ə əlavə edə bilərik
        state.hotels.push(action.payload);
      })
      .addCase(addHotel.rejected, (state, action) => {
        state.status = "failed"; // Əgər şəkil əlavə edilə bilməzsə, failed vəziyyətinə keçirik
        state.error = action.error.message;
      })

      .addCase(getTour.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getTour.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedTour = action.payload;
      })
      .addCase(getTour.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchImagesFromGallery.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchImagesFromGallery.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.images = action.payload;
      })
      .addCase(fetchImagesFromGallery.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default toursSlice.reducer;
